module.exports = __webpack_public_path__ + "img/how-it-works-poster.d7e78e64.jpg";